import { useEffect } from 'react';
import { Grid2 } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import moment from 'moment';
import ExpenseDatePicker from './ExpenseDatePicker';
import { COLORS } from '../../../utils/Application_Constants';

const VendorPaymentEndDate = (props) => {
    const { index, isRequired, expense } = props;
    const { control, errors, watch, setError, clearErrors } = useFormContext({ mode: 'onChange' });
    const expenseCategory = watch(`expenseEntries[${index}].category`);
    const startDate = watch(`expenseEntries[${index}].startDate`) ?? expense.startDate;
    const requiredDateForTravel = expenseCategory === 'Travel';

    const validateEndDate = (value) => {
        if (!value || moment(value).isSameOrAfter(startDate)) {
            return true;
        }

        return 'End Date cannot come before Start Date';
    };

    const handleValidation = (newValue) => {
        const validationResult = validateEndDate(newValue);

        if (validationResult !== true) {
            return setError(`expenseEntries[${index}].endDate`, {
                type: 'manual',
                message: validationResult,
            });
        }

        return clearErrors(`expenseEntries[${index}].endDate`);
    };

    useEffect(() => {
        const currentEndDate = watch(`expenseEntries[${index}].endDate`);
        handleValidation(currentEndDate);
    }, [startDate]);

    return (
        <Grid2 item xs={12} md={6}>
            <Controller
                disabled={props?.isViewOnly ?? false}
                control={control}
                name={`expenseEntries[${index}].endDate`}
                defaultValue={expense.endDate || null}
                rules={{
                    required:
                        isRequired || requiredDateForTravel
                            ? 'End Date is required. Please enter a valid date.'
                            : false,
                    validate: {
                        minDate: validateEndDate,
                    },
                }}
                render={({ onChange, value }) => (
                    <ExpenseDatePicker
                        onChange={(newValue) => {
                            onChange(newValue);
                            handleValidation(newValue);
                        }}
                        value={value ? moment(value) : null}
                        disabled={props?.isViewOnly ?? false}
                        id={`end-date-${index}`}
                        label="End Date"
                        required={isRequired || requiredDateForTravel}
                        parentTextFieldProps={{
                            error: Boolean(errors.expenseEntries?.[index]?.endDate),
                            helperText: errors.expenseEntries?.[index]?.endDate?.message,
                        }}
                        parentSx={{
                            '& .MuiPickersInputBase-root': {
                                borderColor: !errors.expenseEntries?.[index]?.endDate
                                    ? 'default'
                                    : `${COLORS.LT_PEPPER} !important`,
                            },
                        }}
                    />
                )}
            />
        </Grid2>
    );
};

export default VendorPaymentEndDate;
